import { Typography, Box } from '@mui/material'
import { Input } from 'Common/Supplyvue-ui'
import { CreatePlanDataTypes } from '../OperationalPlanner.types'
import { PLAN_DATA_ACTIONS } from './planDataReducer'

interface PlanDescriptionInputProps {
  createPlanDataObject: CreatePlanDataTypes
  dispatch: React.Dispatch<any>
  isPlanCreating: boolean
}

export const PlanDescriptionInput = ({
  createPlanDataObject,
  dispatch,
  isPlanCreating,
}: PlanDescriptionInputProps) => {
  const handleDescriptionChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    dispatch({
      type: PLAN_DATA_ACTIONS.SET_PLAN_DESCRIPTION,
      payload: e.target.value,
    })
  }

  return (
    <Box
      display={'flex'}
      flexDirection="row"
      marginTop={2}
      justifyContent="space-between"
    >
      <Box display="flex" alignItems="center" width="20%">
        <Typography>Plan description</Typography>
      </Box>
      <Box marginLeft={3}>
        <Input
          sx={{ width: '300px' }}
          value={createPlanDataObject.planDescription}
          onChange={handleDescriptionChange}
          disabled={isPlanCreating}
          placeholder="Enter plan description"
        />
      </Box>
      <Box display="flex" alignItems="center" width="20%"></Box>
    </Box>
  )
}
